import keycloakService from '../../keycloak_service';

import { postToSinatra } from '../api_utils';

const removePipeline = (pipeline_id, workspace_id) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({
      pipeline_id,
      workspace_id
    })
  };

  return postToSinatra('v1/api/pipelines/delete_pipeline', fetchOptions);
};

export default removePipeline;
